import React, { useEffect } from 'react'
import _ from 'lodash'
import { useNavigate } from "react-router-dom"
import localStorage from 'localStorage'

import CustomInput from "components/Input"
import CustomButton from "components/Button"
import LoadingModal from 'components/LoadingModal'
import LanguageToggle from 'components/Input/langguageToggle'

import { getTranslation } from 'utils/renderLanguage'
import Logo from 'assets/logo.png'
import LoginHOC from './action'
import './index.scss'

const LoginPage = ({
  onLoginLoad,
  recoverEmail,
  loginCredential,
  showForgetPassword,
  rememberMe,
  savedAccounts,
  showSavedAccounts,

  userLogin,
  recoverPassword,
  onChangeLoginHOC,
  selectSavedAccount,
  removeSavedAccount
}) => {

  const navigate = useNavigate()
  const language = localStorage.getItem( 'english' )

  useEffect( () => {
    const user = JSON.parse( localStorage.getItem( 'userLogin' ) )
    if( user !== null ){
      // localStorage.removeItem( 'userLogin' )
      setTimeout( () => {
        switch( user.role ){
          case 'Super Admin':
            return navigate( '/dashboard/admin/user-management' )
          case 'Admin':
            return navigate( '/dashboard/admin/project-management' )
          case 'Assessor':
            return navigate( '/dashboard/assessor/project-management' )
          case 'Project Leader':
            return navigate( '/dashboard/project-management' )
          case 'Secretariat':
            return navigate( '/dashboard/secretariat/project-management' )
          default:
            return navigate( '/dashboard' )
        }
      }, 1000 )
    }
  }, [navigate])

  const onChangeLogin = ( val, context ) => {
    let tmp = _.cloneDeep( loginCredential )
    tmp[ context ] = val
    onChangeLoginHOC( tmp, "loginCredential" )
  }

  return(
    <div className='at-login__background'>
      <LanguageToggle className={ 'at-login__toggle' }/>
      <div className='at-login__container'>
        <img src={ Logo } alt={ 'login-logo' } />
        {
          !showForgetPassword && (
            <>
              {savedAccounts.length > 0 && (
                <div className="mt-3" style={{ width: '100%', maxWidth: '400px' }}>
                  <button
                    className="btn btn-outline-primary w-100"
                    onClick={() => onChangeLoginHOC(!showSavedAccounts, 'showSavedAccounts')}
                    style={{ marginBottom: '10px' }}
                  >
                    {showSavedAccounts ? 'Hide' : 'Show'} Saved Accounts ({savedAccounts.length})
                  </button>
                  {showSavedAccounts && (
                    <div className="card" style={{ marginBottom: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                      <div className="list-group list-group-flush">
                        {savedAccounts.map((account, index) => (
                          <div 
                            key={index} 
                            className="list-group-item d-flex justify-content-between align-items-center"
                            style={{ padding: '8px 12px' }}
                          >
                            <button
                              className="btn btn-link text-start p-0 flex-grow-1"
                              onClick={() => selectSavedAccount(account)}
                              style={{ textDecoration: 'none', color: '#333' }}
                            >
                              {account.email}
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={(e) => {
                                e.stopPropagation()
                                removeSavedAccount(account.email)
                              }}
                              style={{ padding: '2px 8px', fontSize: '12px' }}
                            >
                              ✕
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
              <CustomInput
                containerClass={ "mt-2 d-flex justify-content-center" }
                className={ "at-login__input" }
                placeholder={ getTranslation( language, 'Email' ) }
                value={ loginCredential.email || '' }
                type={ "text" }
                onChange={ val => onChangeLogin( val, "email" ) }
              />
              <CustomInput
                containerClass={ "mt-2 d-flex justify-content-center" }
                className={ "at-login__input" }
                placeholder={ getTranslation( language, 'Password' ) }
                value={ loginCredential.password || '' }
                type={ "password" }
                onChange={ val => onChangeLogin( val, "password" ) }
              />
              <div className="mt-3 d-flex justify-content-center align-items-center">
                <input
                  type="checkbox"
                  id="rememberMe"
                  checked={ rememberMe }
                  onChange={ (e) => onChangeLoginHOC( e.target.checked, 'rememberMe' ) }
                  style={{ marginRight: '8px', cursor: 'pointer' }}
                />
                <label 
                  htmlFor="rememberMe" 
                  style={{ margin: 0, cursor: 'pointer', userSelect: 'none' }}
                >
                  { getTranslation( language, 'Remember Me' ) }
                </label>
              </div>
              <CustomButton
                disabled={  _.values( loginCredential ).some( x => !x ) }
                containerClass={"mt-4 d-flex justify-content-center"}
                className={ "btn btn-primary at-login__login-button" }
                content={ getTranslation( language, 'Login' ) }
                onClick={ () => userLogin() }
              />
              <CustomButton
                containerClass={ "d-flex justify-content-center" }
                className={ "at-login__forget-password-button" }
                content={ getTranslation( language, 'Forget Password' ) }
                onClick={ () => onChangeLoginHOC( true, 'showForgetPassword' ) }
              />
            </>
          )
        }
        {
          showForgetPassword && (
            <>
              <CustomInput
                containerClass={ "mt-2 d-flex justify-content-center" }
                className={ "at-login__input" }
                placeholder="Email"
                value={ recoverEmail || '' }
                type={ "text" }
                onChange={ val => onChangeLoginHOC( val, 'recoverEmail' ) }
              />
              <CustomButton
                disabled={ !recoverEmail }
                containerClass={"mt-5 d-flex justify-content-center"}
                className={ "btn btn-primary at-login__login-button" }
                content={ "Recover Password" }
                onClick={() => recoverPassword() }
              />
            </>
          )
        }
      </div>
      { onLoginLoad && <LoadingModal /> }
    </div>
  )
}

export default LoginHOC( LoginPage );